// Hook for calculating task hierarchy related UI state (first/last child, parent context).
import { useEffect } from 'react';
import {
  dumpConnectorListDebug,
  isConnectorDebugEnabled,
} from './connectorDebug';
import {
  listDisplayLevel,
  isFirstSiblingInFlatList,
  isLastSiblingInFlatList,
} from '@/features/tasks/hooks/ui/use-task-hierarchy.helpers';
import { useParentContextColor } from '@/features/tasks/hooks/ui/use-task-hierarchy-parent-color';
import { useSiblingConnectorFlags } from '@/features/tasks/hooks/ui/use-task-hierarchy-siblings';

export { isFirstSiblingInFlatList, isLastSiblingInFlatList };

export const useTaskHierarchy = ({
  index,
  tasks,
  displayLevel,
  indentationType,
  isExecutionView,
  view,
  listId = null,
}) => {
  const { isFirstSubtask, isLastSubtask } = useSiblingConnectorFlags({
    index,
    tasks,
    displayLevel,
    indentationType,
    isExecutionView,
  });

  useEffect(() => {
    if (!isConnectorDebugEnabled() || index !== 0 || !tasks?.length) return;

    dumpConnectorListDebug(tasks, {
      indentationType,
      isExecutionView,
      view,
      listId: listId ?? view,
      listDisplayLevel: (task) =>
        listDisplayLevel(task, indentationType, isExecutionView),
      isFirstSiblingInFlatList,
      isLastSiblingInFlatList,
    });
  }, [tasks, indentationType, isExecutionView, view, listId, index]);

  const parentContextColor = useParentContextColor({
    displayLevel,
    index,
    tasks,
    indentationType,
    isExecutionView,
  });

  return { isFirstSubtask, isLastSubtask, parentContextColor };
};
